const UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign'] as const;

export function extractUtmSearch(search: string): string {
  const params = new URLSearchParams(search);
  const kept = new URLSearchParams();
  for (const key of UTM_KEYS) {
    const value = params.get(key);
    if (value !== null && value !== '') {
      kept.set(key, value);
    }
  }
  return kept.toString();
}
